<template>
  <div class="footer_scope">
    <div class="footer_main">
      <div class="footer_cont">
        <i class="icon_logo"></i>
        <p
          class="footer_text"
        >CODE.GAME is a creative coding learning platform for kids from age 7+. Dedicated to empower kids to become creators, we provide 2D/3D graphical coding tools with innovative subjects-acrossed STEAM courses and curriculum.</p>
        <p class="third_links">
          <a target="_blank" :href="community">Courses</a>
          <a target="_blank" :href="ide">Create</a>
        </p>
        <p class="third_icons">
          <a href="https://twitter.com/CodeGameforKids" target="_blank">
            <i class="icon_twitter"></i>
          </a>
          <a
            href="https://www.facebook.com/pg/CodeGame-538735516475093 "
            target="_blank"
          >
            <i class="icon_facebook"></i>
          </a>
          <a href="https://www.instagram.com/codegameforkids/" target="_blank">
            <i class="icon_instagram"></i>
          </a>
          <a
            href="https://www.youtube.com/channel/UCdahagtMreP8vteMOOmC4pw/"
            target="_blank"
          >
            <i class="icon_youtube"></i>
          </a>
        </p>
        <p
          class="footer_text"
        >Learn Computer Programming for Kids 7+ © 2017 CODE.GAME All right reserved</p>
      </div>
      <form @submit.prevent="save" class="contact_us_wrap">
        <p class="contact_us_title">Contact us</p>
        <input
          v-model.trim="form.email_address"
          type="text"
          class="mail_subject"
          placeholder="E-mail"
        >
        <textarea
          v-model.trim="form.content"
          class="mail_content"
          placeholder="Message"
        ></textarea>
        <div class="submit_wrap">
          <span class="submit_tips">Or send an e-mail to us
            <br>info@code.game
          </span>
          <button type="submit" class="btn_submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { post } from '@/utils/ajax'
export default {
  data() {
    const { ide, lab } = CONFIG
    return {
      ide,
      community: lab,
      form: {
        content: '',
        email_address: ''
      }
    }
  },
  methods: {
    async save() {
      const { content, email_address } = this.form
      if (!email_address) return this.$message.error(this.$t('required'))
      if (
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          email_address
        )
      ) {
        return this.$message.error(this.$t('invaild'))
      }
      if (!content) return this.$message.error(this.$t('content'))
      await post(CONFIG.api_backend + '/tiger/marketing/email', this.form)
      this.$message.success(this.$t('success'))
    }
  }
}
</script>

<style lang="scss">
.footer_scope {
  .icon_common {
    display: inline-block;
    background-image: url('~@/common/image/footer.png');
    background-repeat: no-repeat;
  }
  p,
  span {
    font-weight: 200;
  }
  width: 100%;
  padding: 50px 0 60px 0;
  background: #ffffff;
  box-shadow: inset 0 1px 0 0 #ececec;
  position: relative;
  z-index: 15;
  .footer_main {
    width: 1200px;
    margin: 0 auto;
  }
  .footer_cont {
    display: inline-block;
    vertical-align: middle;
    width: 682px;
    margin-right: 120px;
  }
  .icon_logo {
    @extend .icon_common;
    width: 140px;
    height: 20px;
    display: block;
    background-position: -158px -10px;
  }
  .footer_text {
    width: 705px;
    font-size: 14px;
    color: #a7a7a7;
    line-height: 20px;
    margin-top: 19px;
    word-break: keep-all;
  }
  .third_links {
    margin-top: 14px;
    a {
      text-decoration: underline;
      margin-right: 30px;
      color: #868686;
      font-size: 14px;
    }
  }
  .third_icons {
    margin-top: 26px;
    i {
      @extend .icon_common;
      margin-right: 24px;
      display: inline-block;
      vertical-align: middle;
    }
    .icon_twitter {
      width: 24px;
      height: 24px;
      background-position: -100px -258px;
    }
    .icon_facebook {
      width: 24px;
      height: 24px;
      background-position: -132px -256px;
    }
    .icon_instagram {
      width: 24px;
      height: 24px;
      background-position: -164px -256px;
    }
    .icon_youtube {
      width: 24px;
      height: 18px;
      background-position: -196px -260px;
    }
  }
  .contact_us_wrap {
    display: inline-block;
    vertical-align: middle;
    width: 292px;
    overflow: hidden;
  }
  .contact_us_title {
    font-size: 14px;
    color: #868686;
    line-height: 20px;
  }
  .mail_subject {
    width: 100%;
    height: 32px;
    border: 1px solid #dadada;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 5px 10px;
    &::-webkit-input-placeholder {
      color: #a7a7a7;
    }
    &:focus {
      border: 1px solid #fdcb48;
    }
  }
  .mail_content {
    width: 100%;
    height: 106px;
    border: 1px solid #dadada;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 5px 10px;
    resize: none;
    &::-webkit-input-placeholder {
      color: #a7a7a7;
    }
    &:focus {
      border: 1px solid #fdcb48;
    }
  }
  .submit_wrap {
    margin-top: 6px;
  }
  .submit_tips {
    display: inline-block;
    width: 163px;
    margin-right: 48px;
    color: #a7a7a7;
    font-size: 14px;
    vertical-align: middle;
  }
  .btn_submit {
    display: inline-block;
    width: 80px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background: #fdcb48;
    outline: none;
    border: 0;
    color: #fff;
    vertical-align: middle;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background: #ffdd63;
    }
  }
}
</style>
<i18n lang="yaml">
en:
  required: Mail address is requied
  invaild: Mail address is invaild
  content: Content is requied
  success: Thank for your email
zh-CN:
  required: 邮件地址必填
  invaild: 邮件地址不正确
  content: 反馈内容不能为空
  success: 感谢您的反馈
zh-TW:
  required: 郵件地址必填
  invaild: 郵件地址不正確
  content: 反饋內容不能為空
  success: 感謝您的反饋
it:
  required: Indirizzo di posta richiesto
  invaild: Indirizzo di posta non valido
  content: Si richiede contenuto
  success: Grazie per il tuo feedback
id:
  required: Alamat E-mail wajib diisi
  invaild: Format E-mail salah
  content: Wajib diisi
  success: Terima kasih atas E-mail Anda
</i18n>
